module.exports = __webpack_public_path__ + "img/lock-circle.1174ef73.svg";